module.exports = "<div class=\"dashboard-container bg-light-soft\" style=\"height: 100vh\">\n  <div class=\"login-container\">\n  <i class=\"pe-7s-way text-success\" style=\"font-size: 12em;\"></i><span class=\"text-muted\" style=\"font-size: 12em;\">403</span>\n  <h2>Unauthorized</h2>\n  <p> Sorry, but you do not have permissions to access this resource. You have been successfully authenticated, you just haven't been granted the appropriate permissions. </p>\n  <a class=\"btn btn-sm btn-success pull-right\" ui-sref=\"admin\">Return to Home Page</a>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./client/pages/403/unauthorized.html
// module id = 1349
// module chunks = 0